import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
export default mutatorAction('SET_REMINDER_TOAST_ENABLED', function (isEnabled) {
    getStore().reminderToast = isEnabled;
});
//# sourceMappingURL=setReminderToastEnabled.js.map